export const TRADE_PROGRESS_STEPS = [
  { id: '01', value: 1, title: '基本信息确认' },
  { id: '02', value: 2, title: '购买者身份确认' },
  { id: '03', value: 3, title: '数据真实性确认' },
  { id: '04', value: 4, title: '支付费用' },
  { id: '05', value: 5, title: '数据服务' },
  { id: '06', value: 6, title: '售后服务' }
]

export function tradeProgressValue(raw) {
  const n = Number(raw)
  if (!Number.isFinite(n) || n < 1) return 1
  if (n > TRADE_PROGRESS_STEPS.length) return TRADE_PROGRESS_STEPS.length
  return Math.floor(n)
}

export function tradeProgressLabel(raw) {
  const value = tradeProgressValue(raw)
  const step = TRADE_PROGRESS_STEPS.find((item) => item.value === value)
  return step ? step.title : TRADE_PROGRESS_STEPS[0].title
}

export function tradeProgressState(stepValue, raw) {
  const current = tradeProgressValue(raw)
  if (stepValue < current) return 'is-done'
  if (stepValue === current) return 'is-current'
  return 'is-todo'
}
